import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConceptoFoto, Fotografia, FotografiaError } from 'src/app/models/complementos-web/complementos-web.model';
import { FotoError, DragDropMultipleComplementoComponent } from '../drag-drop-multiple-complemento/drag-drop-multiple-complemento.component';
import { HandlerDocumentumClass } from 'src/app/services/documentum/documentum-handler.service';
import { DocumentumStoreFileDetailsIntern } from 'src/app/models/documentum/documentum.model';
import Swal from 'sweetalert2';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { DocumentumService } from 'src/app/services/documentum/documentum.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeAvisoAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { from, lastValueFrom, of, throwError } from 'rxjs';
import { mergeMap, map, catchError, toArray } from 'rxjs/operators';
import { ModulosDocumentumUtilService } from 'src/app/services/documentum/modulos-documento-util.service';
import moment from 'moment';

export interface EstadoTabDocumentos {
  id: string;
  titulo: string;
  archivosValidados: DocumentumStoreFileDetailsIntern[];
  archivosFallidos: FotografiaError[];
  archivosRechazados: FotografiaError[];
  archivosPorSubir: any[];
}

@Component({
    selector: 'app-documentos-seccion-complemento',
    templateUrl: './documentos-seccion-complemento.component.html',
    styleUrls: ['./documentos-seccion-complemento.component.scss'],
    imports: [DragDropMultipleComplementoComponent]
})
export class DocumentosSeccionComplementoComponent extends HandlerDocumentumClass {

  @Input() tabId: number;
  @Input() siniestroConsultado: string;
  @Input() infoArchivo: ConceptoFoto;

  @Output() resumenFinal = new EventEmitter<Partial<EstadoTabDocumentos>>();

  public listaArchivos: DocumentumStoreFileDetailsIntern[] = [];
  public archivosRechazados: FotoError[] = [];

  protected override getArchivos(): DocumentumStoreFileDetailsIntern[] {
    return this.listaArchivos;
  }
  protected override setArchivos(archivos: any[]): void {
    this.listaArchivos = archivos;
  }

  constructor(
    public override store: Store<AppState>,
    public override documentumService: DocumentumService,
    private procesosComplementoService: ProcesosComunesComplementoService,
    public override metadatosDocumentum: ModulosDocumentumUtilService,
    private complementoWebService: ComplementoWebService,
  ) {
    super(store, documentumService);
  }

  onArchivosValidados(archivos: DocumentumStoreFileDetailsIntern[], mostrarAlerta: boolean = true) {
    this.setArchivos(archivos);
    setTimeout(() => {
      this.guardarDocumento(null, mostrarAlerta);
    }, 100);
  }

  onArchivosRechazados(errores: FotoError[]) {
    this.archivosRechazados = errores;
    let erroresFormateados = [];
    this.archivosRechazados.forEach(error => {
      error.errores.forEach(err => erroresFormateados.push(err))
    })
    this.generarMensajeErrorFotografias(erroresFormateados);
  }

  public override guardarDocumento(documento?: DocumentumStoreFileDetailsIntern, mostrarAlerta: boolean = true): void {
    const peticiones = this.getArchivos().filter(doc => {
      return doc.objectId == null || doc.objectId == undefined
    });

    if (peticiones.length == 0) {
      return this.store.dispatch(MostrarMensajeAvisoAction({ titulo: "Aviso", mensaje: "No tienes archivos pendientes por cargar" }))
    }
    this.store.dispatch(ActivarLoadingAction());
    from([1]).pipe(
      mergeMap(archivo =>
        this.guardarFotografias(this.infoArchivo.cve_docto).pipe(
          map((result) => ({ estado: 'ok', result })),
          catchError(err => {
            if (err.status === 401) {
              return throwError(() => err);
            }
            return of({ estado: 'error', result: err.message });
          })
        )
      ),
      toArray()
    ).subscribe(async resultados => {
      try {
        let subidos: any[] = [];
        let fallidos: FotografiaError[] = [];
        let porSubir: DocumentumStoreFileDetailsIntern[] = [];
        if (resultados) {

          resultados.forEach(res => {
            if (res?.estado == 'ok') {
              const fecha = moment().format("YYYY-MM-DD") + "T00:00:00";
              const errores: FotografiaError[] = res?.result?.Resultado?.ErrorListaFotografias;
              const correctos: number[] = res?.result?.Resultado?.RowIdLista;

              if (res?.result?.Exito == false && res?.result?.Mensaje != null) {
                this.store.dispatch(DesactivarLoadingAction());
                return this.procesosComplementoService.alertaGeneralComplemento("Error", res.result?.Mensaje, "info", false, true);
              }

              if (errores?.length) errores.forEach((_, index) => {
                fallidos.push({ error: "No se pudo subir el archivo", nombre: `${this.getArchivos().at(index)?.documentName}` });
              })
              if (correctos?.length) correctos.forEach((identificador, index) => {
                subidos.push({ error: `Archivo cargado ${identificador}`, nombre: `${this.getArchivos().at(index)?.documentName}` });
                porSubir.push({
                  ...this.getArchivos().at(index),
                  attributes: {
                    cve_consec: identificador.toString(),
                    cve_doc: this.infoArchivo.cve_docto.toString(),
                    cve_modulo: "2",
                    cve_submodulo: "1",
                    descripcion: "Complemento Siniestros",
                    estatus: "01",
                    fecha: fecha,
                    fecha_alta: fecha,
                    fecha_estatus: fecha,
                    id_exp: this.infoArchivo.cve_docto.toString(),
                    id_movto: "1",
                    identific: this.metadatosDocumentum.generarCadenaParametros(this.infoArchivo.cve_docto, identificador),
                    referencia: this.siniestroConsultado,
                    rfc: "SIN RFC",
                    tipo_documento: super.evaluarTipoArchivo(this.getArchivos().at(index)?.documentName),
                    tipo_movimiento: "Complemento Siniestros",
                    versiones: "1",
                  }
                });
              })
            }
            else {
              this.getArchivos().forEach(foto => {
                fallidos.push({ error: "No se pudo subir el archivo", nombre: `${foto.documentName}` });
              })
            }
          });
        }

        const rechazados = this.archivosRechazados.map(e => ({
          nombre: e.archivo.name,
          error: e.errores.map(e => e.error).join(",")
        }));

        //Guardar en documento
        if (porSubir.length) {
          const resultDocumentos = await this.almacenarArchivosDocumentum(porSubir);
          const subidosDocumentos = resultDocumentos.filter(e => e.estado == 'ok');
          if (mostrarAlerta == false && subidosDocumentos.length) this.mostrarNotificacionDocumentosReproceso(subidosDocumentos.length);
        }

        this.store.dispatch(DesactivarLoadingAction());
        this.resumenFinal.emit({
          archivosValidados: subidos,
          archivosFallidos: fallidos,
          archivosRechazados: rechazados,
          archivosPorSubir: porSubir
        });
        if (mostrarAlerta) this.mostrarResumen(subidos, fallidos, rechazados);
        this.archivosRechazados = [];
        this.setArchivos([]);
      } catch (error) {
        console.error("Error inesperado en guardarDocumento:", error);
        this.store.dispatch(DesactivarLoadingAction());
        this.resumenFinal.emit({
          archivosValidados: [],
          archivosFallidos: [],
          archivosRechazados: [],
          archivosPorSubir: []
        });
        this.procesosComplementoService.alertaGeneralComplemento("Error", "Ocurrió un error inesperado al guardar los documentos.", "error", false, true);
      }
    }, err => {
      this.store.dispatch(DesactivarLoadingAction());
    });
  }

  mostrarResumen(subidos: any[], fallidos: FotografiaError[], rechazados: FotografiaError[]) {
    const html = `
    <div style="font-size: 16px; text-align: left;">
      <p style="text-align: center;"><b>Resultado de la(s) fotografía(s):</b> <span style="font-weight: bold;">(${this.infoArchivo.descripcion})</span></p>

      <div style="margin-top: 5px; margin-bottom: 5px;">
        <span style="color: green;">✅ Subidos (${subidos.length}):</span>
        <ul style="padding-left: 20px;">${subidos.map(a => `<li>${a.nombre}: <b>${a.error || 'Archivo cargado'}</b></li>`).join('')}</ul>
      </div>

      <div style="margin-top: 5px; margin-bottom: 5px;">
        <span style="color: crimson;">❌ Fallidos (${fallidos.length}):</span>
        <ul style="padding-left: 20px;">${fallidos.map(e => `<li>${e.nombre}: <b>${e.error}</b></li>`).join('')}</ul>
      </div>

      <div style="margin-top: 5px; margin-bottom: 5px;">
        <span style="color: darkred;">🚫 Rechazados (${rechazados.length}):</span>
        <ul style="padding-left: 20px;">${rechazados.map(e => `<li>${e.nombre}: <b>${e.error}</b></li>`).join('')}</ul>
      </div>
    </div>
    `;

    this.procesosComplementoService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, html, '550');
  }


  mostrarNotificacionDocumentosReproceso(contadorArchivos: number): void {
    const mensajeHTML = `
    <p style="text-align: left;">
      Se registraron exitosamente <strong>${contadorArchivos}</strong> documento(s) para el siniestro.<br><br>
      <b>${this.siniestroConsultado}</b><br><br>
    </p>
  `;
    this.procesosComplementoService.alertaGeneralComplemento('¡Aviso!', ``, 'warning', false, true, mensajeHTML);
  }

  generarMensajeErrorFotografias(arrFotografias: FotografiaError[]) {
    let html = `
    <div style="font-size: 16px; text-align: left;">
      <p style="text-align: center;">Error en la(s) fotografía(s):</p><br>
      <div style="margin-top: 5px;">
        <span style="color: darkred; margin-bottom: 5px;">🚫 Rechazados (${arrFotografias.length}):</span>
        <ul style="list-style-type: circle; padding: 0px 0px 15px 25px;">
          ${arrFotografias.map(foto => `<li>${foto.nombre} <b>(${foto.error})</b></li>`).join('')}
        </ul>
      </div>
    </div>
    `;
    this.procesosComplementoService.alertaGeneralComplemento('Aviso', '', 'warning', false, true, html, '500');
  }

  guardarFotografias(cveDocumento: number) {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const fotos = this.getArchivos().map(doc => {
      return {
        nombre: doc.documentName,
        fotografia: `${doc.fullBase64}`
      }
    });
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestro: `${this.siniestroConsultado}`,
      documento: cveDocumento,
      fotografias: this.procesosComplementoService.generarCadenaFotografias(fotos as Fotografia[])
    }
    return this.complementoWebService.guardaFotografias(request);
  }

  async almacenarArchivosDocumentum(archivos: DocumentumStoreFileDetailsIntern[]) {
    const archivosWs = await lastValueFrom(from(archivos).pipe(
      mergeMap(archivo =>
        super.guardarDocumentoDocumentum(archivo).pipe(
          map((result) => ({ estado: 'ok', result })),
          catchError(err => of({ estado: 'error', result: err.message }))
        )
      ),
      toArray()
    ));
    return archivosWs;
  }
}
